const signUpPageTranslations = {
  formTitle: "حول جسمك الآن مع",
  formTitleHook: "إنفورما",
  subtitle: "أنت على بعد نقرة واحدة من تغيير حياتك",
  form: {
    secretKey: "أدخل مفتاحك السري",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    phoneNumber: "رقم الهاتف",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
  },
  steps: {
    secretKey: "مفتاح السر",
    generalInfo: "معلومات عامة",
  },
  cta: {
    back: "العودة",
    submit: "إرسال",
    next: "التالي",
  },
};

export default signUpPageTranslations;
